import { useState } from "react";
import { Archive } from "lucide-react";
import type { DataLoadStatus } from "../types";
import type { CoreDataBundle } from "../data/loaders/coreData";
import type { SituationAnalysis } from "../data/situationAnalysis";
import { downloadDiagnosticZip } from "../utils/diagnosticZip";

export default function DiagnosticExportButton({ bundle, status, range, version, situationAnalysis }: {
  bundle: CoreDataBundle | null;
  status: DataLoadStatus;
  range: string;
  version: string;
  situationAnalysis?: SituationAnalysis;
}) {
  const [exporting, setExporting] = useState(false);
  return (
    <button
      type="button"
      className="diagnostic-button"
      disabled={exporting}
      onClick={async () => {
        if (exporting) return;
        setExporting(true);
        try {
          await downloadDiagnosticZip({ bundle, status, selectedRange: range, appVersion: version, situationAnalysis });
        } finally {
          setExporting(false);
        }
      }}
      title="현재 데이터·메타데이터·오류상태를 ZIP으로 저장합니다. H1B ECOS metadata audit도 기존 서버 Secret을 통해 함께 수집하며 API 키/쿠키/localStorage는 포함하지 않습니다."
    >
      <Archive size={15}/>
      <span>{exporting ? "진단 수집중" : "진단 ZIP"}</span>
    </button>
  );
}
